import React from 'react';
import { View } from 'react-native';
import { Text } from 'react-native-web';
import { getRegularFont } from '../../../../utils/Utils';
//= ========================================================================

const SingleSquareCode = ({
  globJSON, inputNum, simPlatform, withErrorTxt,
}) => {
  const { colors } = globJSON.configurations.theme;
  const myStyles = {
    container: {
      width: 26,
      height: 33,
      marginLeft: 7,
      borderWidth: 1,
      borderRadius: 2.3,
      borderColor: withErrorTxt ? colors.negative_color : colors.border_color,
      textAlign: 'center',
      justifyContent: 'center',
    },
    inputStyle: {
      fontSize: 18.9,
      color: colors.primary_font_color,
      fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
    },
  };
  return (
    <View style={myStyles.container}>
      {withErrorTxt
            && (
            <Text style={myStyles.inputStyle}>
              {inputNum}
            </Text>
            )}
    </View>
  );
};
export default SingleSquareCode;
